import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=189e9673&"
import script from "./TaskList.vue?vue&type=script&lang=js&"
export * from "./TaskList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/timefly-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('189e9673')) {
      api.createRecord('189e9673', component.options)
    } else {
      api.reload('189e9673', component.options)
    }
    module.hot.accept("./TaskList.vue?vue&type=template&id=189e9673&", function () {
      api.rerender('189e9673', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TaskList.vue"
export default component.exports